import { Combo } from './combo.model';
import { Edicao } from './edicao-model';
import { ConteudoProgramaticoEvento } from './conteudo-programatico-evento-model';

export class JustificarEvento
{
    public id : number;
    public justificativa : string;
    public id_edicao_evento : number;
    public id_conteudo_programatico_evento : number;

    public edicao:Edicao;
    public conteudo_programatico_evento:ConteudoProgramaticoEvento;
}


// WEBPACK FOOTER //
// ./src/app/entity/justificar-evento.ts